import * as CubiqTS from "../index";

export class CubiqMessage {
  sizeRead: number = 0;
  message: CubiqTS.ByteBuffer;

  constructor(public totalMessageSize: number, public buffer: ArrayBuffer = null) {
    if (buffer != null) {
      this.message = CubiqTS.ByteBuffer.wrap(buffer, "utf8", false);
    } else {
      this.message = new CubiqTS.ByteBuffer(this.totalMessageSize, false);
    }
  }

  public getMessage(): CubiqTS.ByteBuffer {
    return this.message;
  }
  public read(readSize: number, buf: CubiqTS.ByteBuffer): number {
    return this.readPart(readSize, buf);
  }
  public toString(): string {
    return "TotalMessageSize:" + this.totalMessageSize + ":SizeRead:" + this.sizeRead;
  }
  public isComplete(): boolean {
    if (this.sizeRead === this.totalMessageSize) return true;
    return false;
  }
  public readPart(size: number, buf: CubiqTS.ByteBuffer): number {
    var bufOffset = buf.offset;
    var bufLimit = buf.limit;

    var initialOffset = this.message.offset;
    var sizePartRead;
    var readLimit = buf.offset + size;
    buf.copyTo(this.message, this.message.offset, buf.offset, readLimit);
    // using limit requires manual advancement of offsets
    buf.offset += size;
    this.message.offset += size;

    sizePartRead = this.message.offset - initialOffset;

    if (size !== sizePartRead) {
      throw new Error(
        "readPart: size mismatch" +
          "[size:" +
          size +
          "]" +
          "[sizePartRead:" +
          sizePartRead +
          "]" +
          "[initialOffset:" +
          initialOffset +
          "]" +
          "[bufOffset:" +
          bufOffset +
          "]" +
          "[bufLimit:" +
          bufLimit +
          "]",
      );
    }

    this.sizeRead += sizePartRead;

    return sizePartRead;
  }
}
